<template>
    <div class="confirmModal modal fade" ref="confirmModal" :data-backdrop="backdrop + ''">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header" v-if="$slots.title">
                    <button type="button" class="close" data-dismiss="modal" @click="onCancel">
                        &times;
                    </button>

                    <h4 class="modal-title">
                        <slot name="title"></slot>
                    </h4>
                </div>

                <div class="modal-body">
                    <slot name="body"></slot>
                </div>

                <div class="modal-footer" v-if="showCancel || showConfirm">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="onCancel"
                        v-if="showCancel"
                    >
                        {{ cancelText }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click="onConfirm"
                        v-if="showConfirm"
                    >
                        {{ confirmText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Note that this component requires Bootstrap!

import { $ } from '../assets/vendor';

export default {
    props: {
        confirmText: {
            type: String,
            default: 'OK'
        },
        cancelText: {
            type: String,
            default: 'Cancel'
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        showConfirm: {
            type: Boolean,
            default: true
        },
        backdrop: {
            type: Boolean,
            default: true
        }
    },

    mounted() {
        this.$on('open', actionConfig => {
            $(this.$refs.confirmModal).modal('toggle');
            this.actionConfig = actionConfig;
        });
    },

    methods: {
        onConfirm() {
            if (this.actionConfig && this.actionConfig.hasOwnProperty('onConfirm')) {
                this.actionConfig.onConfirm();
            }
            this.$emit('confirm');
        },

        onCancel() {
            if (this.actionConfig && this.actionConfig.hasOwnProperty('onCancel')) {
                this.actionConfig.onCancel();
            }
            this.$emit('cancel');
        }
    }
};
</script>

<style lang="scss">
.confirmModal {
    .close {
        outline: none;
    }
}
</style>
